var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { UPDATE_TOTAL_RECORDS, UPDATE_PAGE_SIZE, UPDATE_PAGE_NUMBER, SET_OPTIONS, GO_TO_NEXT_PAGE, RESET_BOOK_DATA, SET_RESOLVED_COLUMNS } from '../actions';
export var courseReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = {
        columns: [],
        fixedColumns: [],
        columnHeaders: [],
        filterOptions: {},
        filters: {},
        filteredRecords: [],
        records: [],
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 0,
        fixedValues: {},
        hasServerFilters: false,
        disableInfo: false,
        allowedFilters: [],
        showSearchFilterAfter: Infinity,
        hasOptions: false,
        authMode: "tabs",
        authEntities: [],
        userBillsColumns: [],
        userBookingsColumns: [],
        userPaymentsColumns: [],
        additionalProps: {},
        resolvedColumns: null,
    }; }
    var type = action.type, otherProps = __rest(action, ["type"]);
    switch (action.type) {
        case SET_OPTIONS:
            return __assign(__assign(__assign({}, state), otherProps.options), { hasOptions: true });
        case UPDATE_TOTAL_RECORDS:
        case UPDATE_PAGE_SIZE:
        case UPDATE_PAGE_NUMBER:
            return __assign(__assign({}, state), otherProps);
        case GO_TO_NEXT_PAGE:
            if (action.lastPage && action.lastPage <= state.pageNumber)
                return state;
            return __assign(__assign(__assign({}, state), otherProps), { pageNumber: state.pageNumber + 1 });
        case RESET_BOOK_DATA:
            return __assign(__assign(__assign({}, state), otherProps), { pageNumber: 1 });
        case SET_RESOLVED_COLUMNS:
            return __assign(__assign({}, state), { resolvedColumns: otherProps.reset ? null : Array.from(new Set(__spreadArray(__spreadArray([], ((_a = state.resolvedColumns) !== null && _a !== void 0 ? _a : [])), otherProps.resolvedColumns.split(",")))) });
        default:
            break;
    }
    return state;
};
